import React, { FC } from 'react';
import { GetJobImages_getJobImages as JobImagesList } from '../../../types/schemaTypes';
import './MileageConfirmation.scss';
import MileageConfirmationImageItem from './MileageConfirmationImageItem';

interface JobImagesListProps {
    images: JobImagesList[];
    refetch?: () => void;
    isLoading: boolean;
    onDelete?: (record: any) => void;
    canEditJobs: boolean;
}

const MileageConfirmationImageList: FC<JobImagesListProps> = ({
    images,
    refetch,
    isLoading,
    onDelete,
    canEditJobs,
}: JobImagesListProps): React.ReactElement => {
    if (refetch) {
        refetch();
    }

    return (
        <div className="Images-List">
            {images.map((jobImage, index) => (
                <MileageConfirmationImageItem
                    key={jobImage.id ? jobImage.id.toString() : '0'}
                    index={index}
                    image={jobImage}
                    canEditJobs={canEditJobs}
                    onDelete={onDelete}
                ></MileageConfirmationImageItem>
            ))}
        </div>
    );
};

export default MileageConfirmationImageList;

